import PubSub from "underpub-js";

var AvailabilityMap = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-AvailabilityMap',
	};

	$.extend(true, this.options, options);

	// Gallery properties
	this.$imageWrapper = null;
	this.$dummyImage = null;
	this.$floorImages = [];
	this.currentFloorIndex = null;

};

AvailabilityMap.prototype.init = function() {

	var self = this;

	// Initialize the background image gallery
	this.initGallery();

	// Set the initial floor (default to first floor)
	this.setInitialFloor();

	// Set up floor selector event listener
	this.options.$el.find('.floor-selector').on('change', function () {
		var selectedFloorIndex = parseInt($(this).val(), 10);
		console.log('Selected floor index:', selectedFloorIndex);
		// Convert from 1-based (from dropdown) to 0-based (for JavaScript)
		self.changeFloor(selectedFloorIndex - 1);
	});
	
	// Subscribe to requests for current floor (for late-initializing popups)
	PubSub.subscribe('availabilityMap:requestCurrentFloor', function() {
		if (self.currentFloorIndex !== null) {
			PubSub.publish('availabilityMap:currentFloor', {
				floorIndex: self.currentFloorIndex + 1 // Convert to 1-based
			});
		}
	});

};

/**
 * Initialize the background image gallery
 * Finds the image wrapper and sets up references to all images
 */
AvailabilityMap.prototype.initGallery = function() {

	var self = this;

	// Find the image wrapper element
	this.$imageWrapper = this.options.$el.find('.availability-map_image-wrapper');

	if (!this.$imageWrapper.length) {
		console.warn('AvailabilityMap: Image wrapper not found');
		return;
	}

	// Ensure the wrapper is positioned relatively so absolutely positioned images are contained
	this.$imageWrapper.css({
		position: 'relative'
	});

	// Get all images inside the wrapper
	var $allImages = this.$imageWrapper.find('.availability-map_image');

	if (!$allImages.length) {
		console.warn('AvailabilityMap: No images found in image wrapper');
		return;
	}

	// Find the dummy image (first image with class 'dummy')
	this.$dummyImage = $allImages.filter('.dummy').first();

	if (!this.$dummyImage.length) {
		console.warn('AvailabilityMap: Dummy image not found');
		return;
	}

	// Get all floor images (all images except the dummy)
	// The dummy is positioned relatively, all others should be absolutely positioned
	this.$floorImages = $allImages.not('.dummy');

	// Ensure all floor images are initially hidden (CSS sets opacity: 1, so we override it)
	// Use pointer-events instead of visibility to avoid flashing during transitions
	this.$floorImages.each(function() {
		var $img = $(this);
		$img.css({
			opacity: 0,
			pointerEvents: 'none'
		});
	});

};

/**
 * Set the initial floor (defaults to first floor, index 0)
 * @param {number} floorIndex - Optional floor index (0-based). Defaults to 0.
 */
AvailabilityMap.prototype.setInitialFloor = function(floorIndex) {

	var self = this;

	// Default to first floor if no index provided
	var index = floorIndex !== undefined ? floorIndex : 0;

	// Validate index
	if (index < 0 || index >= this.$floorImages.length) {
		console.warn('AvailabilityMap: Invalid floor index:', index);
		return;
	}

	// Set the initial floor
	this.changeFloor(index);
	
	// Publish initial floor set event (convert to 1-based for popups)
	// Delay slightly to ensure popups have time to subscribe
	var self = this;
	var publishedFloorIndex = index + 1; // Convert to 1-based
	setTimeout(function() {
		console.log('AvailabilityMap: Publishing initialFloorSet', {
			floorIndex: index,
			publishedFloorIndex: publishedFloorIndex
		});
		PubSub.publish('availabilityMap:initialFloorSet', {
			floorIndex: publishedFloorIndex
		});
	}, 50);

};

/**
 * Change the floor and update the background image
 * @param {number} floorIndex - The floor index (0-based)
 */
AvailabilityMap.prototype.changeFloor = function(floorIndex) {

	var self = this;

	// Validate index
	if (floorIndex < 0 || floorIndex >= this.$floorImages.length) {
		console.warn('AvailabilityMap: Invalid floor index:', floorIndex);
		return;
	}

	// Hide current floor image if one is active
	if (this.currentFloorIndex !== null) {
		var $currentImage = this.$floorImages.eq(this.currentFloorIndex);
		$currentImage.css({
			opacity: 0,
			pointerEvents: 'none'
		});
	}

	// Show new floor image
	var $newImage = this.$floorImages.eq(floorIndex);
	$newImage.css({
		opacity: 1,
		pointerEvents: 'auto'
	});

	// Update current floor index
	this.currentFloorIndex = floorIndex;
	
	// Publish floor change event (convert to 1-based for popups)
	var publishedFloorIndex = floorIndex + 1; // Convert to 1-based
	console.log('AvailabilityMap: Publishing floorChanged', {
		floorIndex: floorIndex,
		publishedFloorIndex: publishedFloorIndex
	});
	PubSub.publish('availabilityMap:floorChanged', {
		floorIndex: publishedFloorIndex
	});

};

export default AvailabilityMap;
